export default "__VITE_ASSET__eN2aLThR__"